export default __webpack_public_path__ + "static/media/dish.287e18d6.png";